<template>
    <li>
        <router-link :to="'/' + category.slug">

            <div class="name">
                <span class="text">{{ category.name }}</span>
            </div>
        </router-link>
    </li>
</template>

<script>
    export default {
        name: 'main-category-card',

        props: [
            'list',
            'category'
        ],

        data () {
			return {
                default_category_image: '/vendor/webkul/pwa/assets/images/meduim-product-placeholder.png'
            }
      }
    }


</script>

<style lang="scss" scoped>
    li.category-card {
        display: inline-block;
        width: 135px;
        height: 220px;
        margin-right: 15px;
        background: #FFFFFF;
        box-shadow: 0 6px 10px 0 rgba(0,0,0,0.08), 0 1px 18px 0 rgba(0,0,0,0.08), 0 3px 5px -1px rgba(0,0,0,0.08);

        &:last-child {
            margin-right: 0;
        }

        .image {
            min-height: 135px;
            min-height: 135px;
            img {
                width: 135px;
                height: 135px;
                padding: 3px;
            }
        }

        .name {
            width:100%;
            display: flex;
            align-items: center !important;
            justify-content: center !important;
            color: rgba(0, 0, 0, 0.56);
            line-height:2.5;
            margin: auto;
            text-align: center!important;
            .text{
                margin: auto 10px 0;
                font-size: 12px;
                color: #212121;
                line-height: 18px;
                display: -webkit-box;
                overflow-wrap: break-word;
                // -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                white-space: initial;
                // word-wrap: break-word;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/Resources/assets/js/UI/components/main-category-card.vue